<template>
  <div
    v-if="showEditPopup"
    class="modal right fade"
    id="editOperationModal"
    tabindex="-1"
    aria-labelledby="EditOperationModalLabel"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="handleDialogClose"
          >
            <span aria-hidden="true"><i class="fa fa-times" aria-hidden="true"></i></span>
          </button>
          <span class="headerText" id="EditOperationModal">{{ editOperation }}</span>
        </div>

        <div class="modal-body">
          <div class="content">
            <div class="operation">
              <div v-if="loading" style="position: relative; z-index: 999999; top: 22rem">
                <GridLoading></GridLoading>
              </div>
              <AlertComponent
                v-if="isCancelButtonClicked"
                @setWindow="$emit('visibleDialog', false)"
                :isCancelButtonClicked="isCancelButtonClicked"
                @hidePopup="isCancelButtonClicked = false"
              ></AlertComponent>
              <div>
                <button class="btn btn-primary" style="width: 7rem; border-radius: 5px" @click="onSaveOperationData">
                  {{ $t("editComponent.save") }}
                </button>
                <img
                  style="float: right; padding: 28px; height: 121px; width: 175px"
                  :src="imageUrl"
                  alt="Selected Stitch"
                />
                <div v-if="isMultiComponentThreadEnabled || isMultiComponentThreadSaved" class="expandToComponents">
                  <label v-if="isMultiComponentThreadEnabled">
                    {{ $t("editComponent.expandToComponents") }}
                    <input
                      type="checkbox"
                      v-model="operationInputData.isMultiComponentThread"
                      :disabled="isMultiComponentThreadSaved"
                      @change="onExpandToComponentsChange"
                    />
                  </label>
                  <span v-else>{{ $t("editComponent.operationIsExpanded") }}</span>
                </div>
                <div class="entry">
                  <div class="inputGroup">
                    <label class="label" for="tbox1">{{ $t("editComponent.group") }}</label>
                    <input
                      class="input"
                      type="number"
                      id="tbox1"
                      name="tbox1"
                      min="1"
                      value="editComponent.group"
                      v-model="operationInputData.group"
                      required
                    />
                  </div>

                  <div class="team">
                    <label class="label" for="team">{{ $t("editComponent.team") }}</label>
                    <div>
                      <toggle-button
                        v-model="operationInputData.isOnTeam"
                        :height="22"
                        :width="50"
                        checkedText="On"
                        uncheckedText="Off"
                        checkedBg=" #0054a6"
                        uncheckedBg="lightgrey"
                        color="#0054a6"
                        @click="setTeam(operationInputData.isOnTeam)"
                      />
                    </div>
                  </div>
                </div>

                <div class="seam-details-box" v-if="isV4CalculationEngine">
                  <fieldset>
                    <legend>{{ $t("editComponent.seamDetails") }}</legend>

                    <div class="seam-row">
                      <label for="numberOfPlies">{{ $t("editComponent.numberOfPlies") }}</label>
                      <input
                        class="seam-input"
                        type="number"
                        min="1"
                        max="999999"
                        step="1"
                        v-model.number="operationInputData.numberOfPlies"
                        id="numberOfPlies"
                      />
                    </div>

                    <div class="seam-row">
                      <label for="avgMaterialThickness"
                        >{{ $t("editComponent.averageMaterialThickness") }} ({{ unitLabel }})</label
                      >
                      <input
                        class="seam-input"
                        type="number"
                        min="0"
                        max="999.99999"
                        step="0.00001"
                        v-model="materialThicknessDisplay"
                        id="avgMaterialThickness"
                      />
                    </div>

                    <div class="seam-row">
                      <label for="buttonThickness"
                        >{{ $t("editComponent.averageButtonThickness") }} ({{ unitLabel }})</label
                      >
                      <input
                        class="seam-input"
                        type="number"
                        min="0"
                        max="999.99999"
                        step="0.00001"
                        v-model="buttonThicknessDisplay"
                        id="buttonThickness"
                      />
                    </div>

                    <div class="seam-row">
                      <label for="avgThreadDiameter"
                        >{{ $t("editComponent.averageThreadDiameter") }} ({{ unitLabel }})</label
                      >
                      <input
                        class="seam-input"
                        type="number"
                        min="0"
                        max="999.99999"
                        step="0.00001"
                        v-model="threadDiameterDisplay"
                        id="avgThreadDiameter"
                      />
                    </div>

                    <div class="seam-row">
                      <label for="wastagePerSeam">{{ $t("editComponent.wastagePerSeam") }} ({{ unitLabel }})</label>
                      <input
                        class="seam-input"
                        type="number"
                        min="0"
                        max="99999.99"
                        step="0.01"
                        v-model="wastagePerSeamDisplay"
                        id="wastagePerSeam"
                      />
                    </div>

                    <div class="seam-row" v-if="showNeedleDistance">
                      <label for="needleDistance">{{ $t("editComponent.needleDistance") }} ({{ unitLabel }})</label>
                      <input
                        v-if="isNeedleDistanceEditable"
                        class="seam-input"
                        :class="{ errorStyle: needleDistanceHasError }"
                        type="number"
                        min="0"
                        :max="needleDistanceMax"
                        step="0.01"
                        v-model="needleDistanceDisplay"
                        id="needleDistance"
                      />
                      <span v-else class="seam-value">{{ needleDistanceDisplay }}</span>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div class="body">
                <label class="label" for="description">{{ $t("editComponent.description") }}</label>

                <textarea
                  id="description"
                  name="tbox1"
                  class="textArea"
                  :class="{ errorStyle: descHasError }"
                  :maxlength="225"
                  :placeholder="addDescription"
                  rows="4"
                  cols="33"
                  :value="operationInputData.description"
                  @input="setDescription($event.target)"
                  required
                ></textarea>
                <span class="counter">{{ operationInputData.description?.length }}/225</span>
              </div>
              <div class="operationType" v-if="isV4CalculationEngine">
                <label class="label1" for="operationType">{{ $t("editComponent.operationType") }}</label>
                <ComboBox
                  id="operationType"
                  :data-source="operationTypeOptions"
                  :data-text-field="'label'"
                  :data-value-field="'value'"
                  :class="{ errorStyle: operationTypeHasError }"
                  :height="275"
                  :filter="'contains'"
                  :placeholder="'Select'"
                  v-model="operationInputData.operationType"
                  @change="handleOperationTypeChange($event.sender._cascadedValue)"
                >
                </ComboBox>
              </div>
              <div class="stitchType">
                <label class="label1" for="stitchType">{{ $t("editComponent.stitchType") }}</label>
                <ComboBox
                  :data-source="stitchTypeData[0]"
                  :class="{ errorStyle: stitchHasError }"
                  :height="275"
                  :maxlength="30"
                  :filter="'contains'"
                  v-model="operationInputData.stitchTypeCode"
                  @change="getStitchCode($event.sender._cascadedValue)"
                >
                </ComboBox>
              </div>
              <div>
                <div class="formComponent" v-if="showSeamLength">
                  <!-- Button Hole/Bartack/Button Sew/Auto Cycle enter a stitch count here, not a length, so no unit is shown. -->
                  <label
                    v-if="isV4CalculationEngine && ['BH', 'BT', 'BS', 'AC'].includes(operationInputData.operationType)"
                    class="label"
                    for="seamLength"
                    >{{ $t("editComponent.stitchCount") }}</label
                  >
                  <label v-else-if="seamLengthUnit == 0" class="label" for="seamLength"
                    >{{ $t("editComponent.seamLength") }}(Cm)</label
                  >
                  <label v-else class="label" for="seamLength">{{ $t("editComponent.seamLength") }}(inch)</label>
                  <input
                    class="input"
                    :class="{ errorStyle: seamLengthHasError }"
                    type="number"
                    min="0"
                    step=".01"
                    v-model="operationInputData.seamLength"
                    required
                    style="width: 9em !important"
                    id="seamLength"
                  />
                </div>
                <div class="formComponent" v-if="showRate">
                  <label v-if="seamLengthUnit == 0" class="label" for="stitchRate"
                    >{{ $t("editComponent.stitch") }}/3Cm</label
                  >
                  <label v-else class="label" for="stitchRate">{{ $t("editComponent.stitch") }}/inch</label>
                  <input
                    class="input"
                    type="number"
                    min="0"
                    step=".01"
                    v-model="operationInputData.rate"
                    style="width: 9em !important"
                    id="stitchRate"
                  />
                </div>
                <div class="formComponent" v-if="showBight">
                  <label v-if="seamLengthUnit == 0" class="label" for="bight"
                    >{{ $t("editComponent.bight") }}(mm)</label
                  >
                  <label v-else class="label" for="bight">{{ $t("editComponent.bight") }}(inch)</label>
                  <input
                    class="input"
                    :class="{ errorStyle: bightHasError }"
                    type="number"
                    min="0"
                    step=".01"
                    v-model="operationInputData.bight"
                    @input="onBightChange"
                    style="width: 9em !important"
                    id="bight"
                  />
                </div>
              </div>
              <div>
                <div class="formComponent" v-if="showQuantity">
                  <label class="label" for="quantity">{{ $t("editComponent.row/Quantity") }}</label>
                  <input
                    class="input"
                    type="number"
                    min="1"
                    step=".01"
                    v-model="operationInputData.quantity"
                    style="width: 9em !important"
                    id="quantity"
                  />
                </div>
                <div class="formComponent">
                  <label class="label" for="machines">{{ $t("editComponent.machines") }}</label>
                  <input
                    class="input"
                    :class="{ errorStyle: machineHasError }"
                    type="number"
                    min="1"
                    v-model="operationInputData.machines"
                    required
                    style="width: 9em !important"
                    id="machines"
                  />
                </div>

                <div class="formComponent" v-if="showSeamThickness && !isV4CalculationEngine">
                  <label class="label" for="seamThickness">{{ $t("editComponent.seamThickness") }}(mm)</label>
                  <input
                    class="input"
                    :class="{ errorStyle: seamThicknessHasError }"
                    type="number"
                    min="1"
                    step=".1"
                    v-model="operationInputData.seamThikness"
                    style="width: 9em !important"
                    id="seamThickness"
                  />
                </div>
              </div>
              <div class="footer">
                <div v-if="showHeader" class="child">
                  <table class="needlesTable">
                    <thead>
                      <tr>
                        <th>{{ $t("operationCreateComp.component") }}</th>
                        <th>{{ consumptionHeader }}</th>
                        <th>{{ $t("editComponent.brand") }}</th>
                        <th>{{ ticketTex == "Tkt" ? $t("editComponent.tkt") : $t("editComponent.tex") }}</th>
                        <th>{{ $t("editComponent.shade") }}</th>
                        <th>{{ $t("editComponent.packageSize") }}</th>
                      </tr>
                    </thead>
                    <tbody v-if="!operationInputData.isMultiComponentThread">
                      <tr v-for="(item, id) in operationInputData.styleOperations" :key="id">
                        <td style="text-align: left">{{ item.needleName }}</td>
                        <td>{{ consumptionValues[id] }}</td>
                        <td>
                          <ComboBox
                            :data-source="brandData.length ? brandData : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="brandName[id]"
                            :value="brandName[id]"
                            style="width: 10em !important; font-size: 12px"
                            @change="handleBrandChange($event.sender._cascadedValue, id)"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="tktTexData.length ? tktTexData : []"
                            :data-text-field="'value'"
                            :data-value-field="'text'"
                            :height="130"
                            :filter="'contains'"
                            :key="'id'"
                            v-model="operationInputData.styleOperations[id].ticketTex"
                            :value="operationInputData.styleOperations[id].ticketTex"
                            style="width: 7em !important; font-size: 12px !important"
                            @change="handleTktTexChange($event.sender._cascadedValue, id)"
                            @open="getPackageSizeData($event.sender._cascadedValue, id)"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="shadeData.length ? shadeData : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :filter="'contains'"
                            :height="130"
                            :key="'id'"
                            v-model="operationInputData.styleOperations[id].shade"
                            :value="operationInputData.styleOperations[id].shade"
                            style="width: 9.1em !important; font-size: 12px !important"
                          >
                          </ComboBox>
                        </td>
                        <td>
                          <ComboBox
                            :data-source="packageSizeData.length ? packageSizeData : []"
                            :data-text-field="'text'"
                            :data-value-field="'value'"
                            :filter="'contains'"
                            :height="130"
                            :key="'id'"
                            v-model="operationInputData.styleOperations[id].packageSize"
                            :value="operationInputData.styleOperations[id].packageSize"
                            @open="getPackageSizeData(operationInputData.styleOperations[id].ticketTex, id)"
                            style="width: 8em !important; font-size: 12px"
                          >
                          </ComboBox>
                        </td>
                      </tr>
                    </tbody>
                    <!-- expanded to components - head row, then one row per part -->
                    <tbody v-else>
                      <tr
                        v-for="(row, rid) in componentDisplayRows"
                        :key="rid"
                        :class="{ headRow: row.isHead, componentRow: row.divisor > 1 }"
                      >
                        <td style="text-align: left">
                          {{ row.displayName }}
                          <span v-if="row.isHead" class="componentCount"> ({{ row.heads }})</span>
                        </td>
                        <td>{{ row.divisor > 1 ? row.consumption : consumptionValues[row.headPosition] }}</td>
                        <td v-if="row.isHead" colspan="4" class="chosenPerComponent">
                          {{ $t("editComponent.chosenPerComponentBelow") }}
                        </td>
                        <template v-else>
                          <td>
                            <ComboBox
                              :data-source="brandData.length ? brandData : []"
                              :data-text-field="'text'"
                              :data-value-field="'value'"
                              :height="130"
                              :filter="'contains'"
                              :key="'id'"
                              v-model="brandName[row.leafIndex]"
                              :value="brandName[row.leafIndex]"
                              style="width: 10em !important; font-size: 12px"
                              @change="handleBrandChange($event.sender._cascadedValue, row.leafIndex)"
                            >
                            </ComboBox>
                          </td>
                          <td>
                            <ComboBox
                              :data-source="tktTexData.length ? tktTexData : []"
                              :data-text-field="'value'"
                              :data-value-field="'text'"
                              :height="130"
                              :filter="'contains'"
                              :key="'id'"
                              v-model="operationInputData.styleOperations[row.leafIndex].ticketTex"
                              :value="operationInputData.styleOperations[row.leafIndex].ticketTex"
                              style="width: 7em !important; font-size: 12px !important"
                              @change="handleTktTexChange($event.sender._cascadedValue, row.leafIndex)"
                              @open="getPackageSizeData($event.sender._cascadedValue, row.leafIndex)"
                            >
                            </ComboBox>
                          </td>
                          <td>
                            <ComboBox
                              :data-source="shadeData.length ? shadeData : []"
                              :data-text-field="'text'"
                              :data-value-field="'value'"
                              :filter="'contains'"
                              :height="130"
                              :key="'id'"
                              v-model="operationInputData.styleOperations[row.leafIndex].shade"
                              :value="operationInputData.styleOperations[row.leafIndex].shade"
                              style="width: 9.1em !important; font-size: 12px !important"
                            >
                            </ComboBox>
                          </td>
                          <td>
                            <ComboBox
                              :data-source="packageSizeData.length ? packageSizeData : []"
                              :data-text-field="'text'"
                              :data-value-field="'value'"
                              :filter="'contains'"
                              :height="130"
                              :key="'id'"
                              v-model="operationInputData.styleOperations[row.leafIndex].packageSize"
                              :value="operationInputData.styleOperations[row.leafIndex].packageSize"
                              @open="
                                getPackageSizeData(
                                  operationInputData.styleOperations[row.leafIndex].ticketTex,
                                  row.leafIndex
                                )
                              "
                              style="width: 8em !important; font-size: 12px"
                            >
                            </ComboBox>
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <p v-if="showHeader && !isV4CalculationEngine" class="wastageNote">
                  {{ $t("styleGrid.threadWastageNote") }}
                </p>

                <div class="buttons">
                  <button class="btn btn-primary" style="width: 7rem; border-radius: 5px" @click="onSaveOperationData">
                    {{ $t("editComponent.save") }}
                  </button>
                  <button
                    class="btn btn-secondary"
                    style="width: 8rem; border-radius: 5px; margin-left: 10px"
                    @click="handleDialogClose"
                  >
                    {{ $t("editComponent.cancel") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Dialog } from "@progress/kendo-vue-dialogs";
import { DropDownList, ComboBox } from "@progress/kendo-dropdowns-vue-wrapper";
import AlertComponent from "./AlertComponent.vue";
import GridLoading from "./GridLoading.vue";
import {
  StitchTypeApi,
  StitchNBLCTypesApi,
  TicketTexApi,
  BrandApi,
  PackageSizeApi,
  ShadeApi,
  StyleOperationApi
} from "@/api";
import { OperationType, StyleOperationNBLC } from "@/api/model";
import {
  buildDisplayRows,
  buildLeafRows,
  toHeadTypes,
  type ComponentDisplayRow
} from "@/core/utils/ComponentRowsHelper";
import { OPERATION_TYPE_OPTIONS, normalizeOperationType } from "@/core/utils/OperationTypeOptions";
import { isEditableNeedleDistanceStitchType } from "@/core/utils/EditableNeedleDistanceStitchTypes";
import { isInvalidOperationStitchType } from "@/core/utils/RestrictedOperationStitchTypes";
import { gsdV4StitchTypeNeedsBight, V4_DEFAULT_BIGHT_IN_MM, V4_MAX_BIGHT_IN_MM } from "@/core/utils/V4BightStitchTypes";
import { useToast } from "vue-toastification";
import { defineComponent } from "vue";
import VueToggles from "vue-toggles";
import { getConsumptionHeader } from "@/core/utils/ConsumptionHelper";

export default defineComponent({
  name: "EditComponent",
  emits: ["visibleDialog", "getOperationData", "operationId"],
  setup() {
    const stitchTypeApi = new StitchTypeApi()!;
    const stitchNBLCTypesApi = new StitchNBLCTypesApi()!;
    const brandApi = new BrandApi()!;
    const ticketTexApi = new TicketTexApi()!;
    const packageSizeApi = new PackageSizeApi()!;
    const shadeApi = new ShadeApi()!;
    const styleOperationApi = new StyleOperationApi()!;
    return {
      stitchTypeApi,
      stitchNBLCTypesApi,
      brandApi,
      ticketTexApi,
      packageSizeApi,
      shadeApi,
      styleOperationApi
    };
  },
  components: {
    "k-dialog": Dialog,
    ComboBox,
    DropDownList,
    AlertComponent,
    GridLoading,
    "toggle-button": VueToggles
  },
  props: {
    showEditPopup: null as any,
    operationId: null as any,
    seamLengthUnit: null as any,
    calculationEngineType: {
      type: String,
      default: ""
    },
    isMultiComponentThreadEnabled: {
      type: Boolean,
      default: false
    },
    consumptionData: null as any,
    ticketTex: null as any,
    isMaximized: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isV4CalculationEngine(): boolean {
      const engineType = String(this.calculationEngineType ?? "")
        .trim()
        .toLowerCase();
      return engineType === "gsdv4";
    },
    consumptionHeader(): string {
      const stitchTypeCode = this.operationInputData?.stitchTypeCode ?? undefined;
      return getConsumptionHeader(this.seamLengthUnit, stitchTypeCode);
    },
    // Rows of the expanded thread table: head row + one row per part.
    componentDisplayRows(): ComponentDisplayRow[] {
      const rows = buildDisplayRows(this.headTypes, true);
      // the rows are shown only once there is a thread row for every part; while the stitch type is being
      // changed the thread rows are briefly empty (null) and must not be read
      const partRowCount = rows.filter(row => !row.isHead).length;
      if ((this.operationInputData.styleOperations?.length ?? 0) < partRowCount) {
        return [];
      }
      return rows;
    },
    // Needle count comes from the stitch type's NBLC rows (loaded into needleCount when the stitch changes/loads),
    // not from StitchType.Needles.
    selectedStitchNeedles(): number {
      return Number(this.needleCount ?? 0);
    },
    // True only when the new GSD V4 Bight rule applies to this operation. False means "leave everything
    // as it was", so on the Seamworks engine nothing changes, whether Bight is shown there or not.
    applyV4BightRule(): boolean {
      if (this.isV4CalculationEngine && gsdV4StitchTypeNeedsBight(this.operationInputData.stitchTypeCode)) {
        return true;
      } else {
        return false;
      }
    },
    // Editable for the listed GSD V4 stitch types; read-only (derived) for other multi-needle types.
    isNeedleDistanceEditable(): boolean {
      return this.isV4CalculationEngine && isEditableNeedleDistanceStitchType(this.operationInputData?.stitchTypeCode);
    },
    showNeedleDistance(): boolean {
      return this.isNeedleDistanceEditable || (this.isV4CalculationEngine && this.selectedStitchNeedles > 1);
    },
    needleDistance(): number {
      const needles = this.selectedStitchNeedles;
      if (needles <= 1) return 0;
      const bight = Number(this.operationInputData?.bight ?? 0);
      const value = Number((bight / (needles - 1)).toFixed(2));
      return Number.isFinite(value) ? value : 0;
    },
    // Upper bound shown to the user, in the box's unit (CM in metric, inch in imperial).
    needleDistanceMax(): number {
      return this.toNeedleDistanceDisplay(Number(this.operationInputData?.bight ?? 0));
    },
    // Needle distance is shown in the same unit as the other seam-detail fields (CM / inch). The value is held
    // internally in the Bight unit (mm / inch) for the <= Bight check, so metric display divides by 10.
    needleDistanceDisplay: {
      get(): any {
        const internal = this.operationInputData?.needleDistance;
        const value = internal === null || internal === undefined ? this.needleDistance : internal;
        return this.toNeedleDistanceDisplay(value);
      },
      set(value: any) {
        if (value === "" || value === null || value === undefined || Number.isNaN(Number(value))) {
          this.operationInputData.needleDistance = null;
          return;
        }
        this.operationInputData.needleDistance =
          this.seamLengthUnit == 0 ? Number((Number(value) * 10).toFixed(2)) : Number(value);
      }
    },
    unitLabel(): string {
      return this.seamLengthUnit == 0 ? "CM" : "inch";
    },
    // Display bindings: cm is always stored; inches are shown only in imperial. Untouched fields keep their exact cm.
    materialThicknessDisplay: {
      get(): any {
        return this.toDisplayValue(this.operationInputData.materialThickness, 5);
      },
      set(value: any) {
        this.operationInputData.materialThickness = this.toCmValue(value, 5);
      }
    },
    buttonThicknessDisplay: {
      get(): any {
        return this.toDisplayValue(this.operationInputData.buttonThickness, 5);
      },
      set(value: any) {
        this.operationInputData.buttonThickness = this.toCmValue(value, 5);
      }
    },
    threadDiameterDisplay: {
      get(): any {
        return this.toDisplayValue(this.operationInputData.threadDiameter, 5);
      },
      set(value: any) {
        this.operationInputData.threadDiameter = this.toCmValue(value, 5);
      }
    },
    wastagePerSeamDisplay: {
      get(): any {
        return this.toDisplayValue(this.operationInputData.wastagePerSeam, 2);
      },
      set(value: any) {
        this.operationInputData.wastagePerSeam = this.toCmValue(value, 2);
      }
    }
  },
  mounted() {
    if (this.showEditPopup) {
      this.$nextTick(() => {
        ($("#editOperationModal") as any).modal("show");
      });
    }
    ($("#editOperationModal") as any).modal({
      backdrop: false,
      keyboard: false,
      focus: false
    });
  },
  data() {
    return {
      operationIdLocal: this.operationId,
      toast: useToast(),
      visibleDialog: null as any,
      stitchTypeData: [] as any,
      brandData: [] as any,
      tktTexData: [] as any,
      packageSizeData: [] as any,
      shadeData: [] as any,
      styleId: sessionStorage.getItem("styleId"),
      hasError: false,
      descHasError: false,
      stitchHasError: false,
      seamLengthHasError: false,
      machineHasError: false,
      seamThicknessHasError: false,
      numberOfPliesHasError: false,
      materialThicknessHasError: false,
      buttonThicknessHasError: false,
      threadDiameterHasError: false,
      wastagePerSeamHasError: false,
      needleDistanceHasError: false,
      bightHasError: false,
      operationStitchTypeHasError: false,
      operationTypeHasError: false,
      operationTypeOptions: OPERATION_TYPE_OPTIONS,
      groupHasError: false,
      stitch: "",
      loading: false,
      editOperation: this.$t("editComponent.editOperation"),
      addDescription: this.$t("editComponent.addDescriptionHere"),
      showHeader: false,
      stylesData: [] as any,
      showBight: true,
      showSeamLength: true,
      showQuantity: true,
      showSeamThickness: true,
      showRate: true,
      bightConversionFactor: 1,
      seamlengthConversionFector: 1,
      rateConversionFactor: 1,
      isCancelButtonClicked: false,
      operationInputData: [] as any,
      consumptionValues: [] as any,
      brandName: {} as any,
      imageUrl: "/StitchTypeImages/EmptyImage.jpg",
      isStitchTypeValidation: [] as any,
      editSwitch: this.isEditSwitched,
      selectValueFromList: (this.$t("operationCreateComp.error") +
        ": " +
        this.$t("itemSelectModal.pleaseSelect") +
        " " +
        this.$t("itemSelectModal.fromTheList")) as string,
      needlesList: [] as any,
      // Head types of the stitch type with their parts, used only when expanded to components.
      headTypes: [] as any,
      // Rows as they were before ticking "Expand to Components", restored when it is unticked before saving.
      rowsBeforeExpand: null as any,
      initialPackageSizeData: {} as any,
      defaultStitchData: [] as any,
      // Needle count for the selected stitch type, derived from its NBLC rows (sum of Heads for needle rows).
      needleCount: 0 as number,
      isMultiComponentThreadSaved: false
    };
  },
  watch: {
    async operationId(newVal) {
      await this.onSaveOperationData();
      if (newVal && this.operationId) {
        this.operationIdLocal = this.operationId;
        await this.loadData();
      }
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.operationInputData.styleId = this.styleId as unknown as number;
      await this.getBrandData();
      await this.getStitchTypeData();
      await this.setEditOperationData();
      this.setConversionFactor(this.seamLengthUnit);
      this.loading = false;
    },
    handleBrandChange(selectedBrandId: any, id: any) {
      const isValid = this.brandData.some((item: any) => item.value == selectedBrandId);
      if (selectedBrandId === null || selectedBrandId === undefined || String(selectedBrandId).trim() === "") {
        this.isStitchTypeValidation[id] = true;
        this.operationInputData.styleOperations[id].ticketTex = null;
        this.getTktTexData(selectedBrandId, id);
      } else if (isValid) {
        this.isStitchTypeValidation[id] = true;
        // a new brand needs its own Tkt; the old one may not exist for this brand
        this.operationInputData.styleOperations[id].ticketTex = null;
        this.operationInputData.styleOperations[id].packageSize = null;
        this.getTktTexData(selectedBrandId, id);
      } else {
        this.isStitchTypeValidation[id] = false;
        this.toast.error(this.selectValueFromList, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    handleTktTexChange(selectedId: any, id: any) {
      const isValid = this.tktTexData.some((item: any) => item.value == selectedId);
      if (selectedId === null || selectedId === undefined || String(selectedId).trim() === "") {
        this.isStitchTypeValidation[id] = true;
        this.operationInputData.styleOperations[id].ticketTex = null;
      } else if (isValid) {
        this.isStitchTypeValidation[id] = true;
        this.getPackageSizeData(selectedId, id);
      } else {
        this.isStitchTypeValidation[id] = false;
        this.toast.error(this.selectValueFromList, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    handleDialogClose() {
      this.isCancelButtonClicked = true;
      this.backdropClose();
    },
    backdropClose() {
      setTimeout(() => {
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();

        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("padding-right");
        document.body.style.removeProperty("overflow");
      }, 300);
    },
    async setEditOperationData(): Promise<void> {
      await this.styleOperationApi
        .apiGetOperationGet(
          this.operationIdLocal,
          sessionStorage.getItem("styleId") as unknown as number,
          this.seamLengthUnit,
          this.ticketTex as string
        )
        .then(async res => {
          this.operationInputData = res.data;
        });
      this.operationInputData.numberOfPlies = (this.operationInputData as any).numberOfPlies ?? 1;
      this.operationInputData.materialThickness = (this.operationInputData as any).materialThickness ?? null;
      this.operationInputData.buttonThickness = (this.operationInputData as any).buttonThickness ?? null;
      this.operationInputData.threadDiameter = (this.operationInputData as any).threadDiameter ?? null;
      this.operationInputData.wastagePerSeam = (this.operationInputData as any).wastagePerSeam ?? 0;
      this.operationInputData.operationType =
        normalizeOperationType((this.operationInputData as any).operationType) ?? OperationType.Sew;
      this.operationInputData.isMultiComponentThread = (this.operationInputData as any).isMultiComponentThread ?? false;
      this.isMultiComponentThreadSaved = this.operationInputData.isMultiComponentThread;
      this.operationInputData.seamLengthUnit = this.seamLengthUnit;
      this.operationInputData.id = this.operationIdLocal;
      this.getBrandNameById();
      this.getComponentData(this.operationInputData.stitchTypeCode as string);
      this.setConsumptionData(this.operationInputData.stitchTypeCode);
      this.loadNeedleCount(this.operationInputData.stitchTypeCode);
      this.removingNonRequiredField();
      this.selectedImageUrl();
    },
    setDescription(target: EventTarget | null): void {
      const val = (target as HTMLInputElement).value;
      this.operationInputData.description = val.replace(",", " ");
    },
    setConsumptionData(StitchCode: string): void {
      this.consumptionValues = [];
      this.consumptionValues.push(
        this.consumptionData[StitchCode].headType1Consumption,
        this.consumptionData[StitchCode].headType2Consumption,
        this.consumptionData[StitchCode].headType3Consumption,
        this.consumptionData[StitchCode].headType4Consumption
      );
    },
    selectedImageUrl(): any {
      if (
        this.operationInputData.stitchTypeCode == null ||
        this.operationInputData.stitchTypeCode == undefined ||
        this.operationInputData.stitchTypeCode == ""
      ) {
        return `/StitchTypeImages/EmptyImage.jpg`;
      } else {
        let stitchCode = this.operationInputData.stitchTypeCode.includes("-")
          ? this.operationInputData.stitchTypeCode?.split("-")[0]
          : this.operationInputData.stitchTypeCode;
        const imageName = stitchCode.replaceAll(/\s+/g, "");
        const imageUrl = `/StitchTypeImages/${imageName}.jpg`;
        switch (imageName) {
          case "1012":
          case "1013":
          case "1014":
          case "1016":
          case "3012":
          case "3013":
          case "3015":
          case "3042":
          case "3043":
          case "3045":
          case "4012":
          case "4013":
          case "4013G":
          case "4012G":
          case "4041":
          case "4042":
          case "4043":
          case "4045":
          case "4083": {
            this.imageUrl = "/StitchTypeImages/EmptyImage.jpg";
            break;
          }
          //the non ISO stitch types exist only for the GSD V4 engine, so they have no image under Seamworks.
          case "202":
          case "315":
          case "316":
          case "329":
          case "351":
          case "510":
          case "511":
          case "513":
          case "521":
          case "522":
          case "603":
          case "608": {
            this.imageUrl = this.isV4CalculationEngine ? imageUrl : "/StitchTypeImages/EmptyImage.jpg";
            break;
          }
          default: {
            this.imageUrl = imageUrl;
            break;
          }
        }
      }
    },
    setTeam(val: boolean): void {
      this.operationInputData.isOnTeam = val;
    },
    validateDescription(): boolean {
      if (this.operationInputData.description == null || this.operationInputData.description.trim() == "") {
        this.descHasError = true;
        this.toast.error(this.$t("editComponent.pleaseEnterDescription") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.descHasError = false;
      }
      return this.descHasError;
    },
    validateSeamThickness(): void {
      if (this.isV4CalculationEngine) {
        this.seamThicknessHasError = false;
        return;
      }
      switch (this.operationInputData.stitchTypeCode) {
        case "301":
        case "319":
        case "401":
        case "401A":
        case "4012G":
        case "406":
        case "407":
        case "409":
        case "504":
        case "514":
        case "516":
        case "602":
        case "605":
        case "607":
        case "607K": {
          if ((this.operationInputData.seamThikness ? this.operationInputData.seamThikness : 0) <= 0) {
            this.seamThicknessHasError = true;
            this.toast.error(this.$t("operationCreateComp.seamThicknessShouldBeGreaterThan0") as string, {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          } else {
            this.seamThicknessHasError = false;
          }
          break;
        }
      }
    },
    // Number of plies: optional; integer 1–999999 when entered.
    validateNumberOfPlies(): boolean {
      this.numberOfPliesHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.numberOfPlies;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      if (isBlank) {
        // Plies is required under V4 and defaults to 1 — normalize a blank value so it's never sent as null.
        this.operationInputData.numberOfPlies = 1;
        return false;
      }
      const num = Number(raw);
      if (Number.isNaN(num) || !Number.isInteger(num) || num < 1 || num > 999999) {
        this.numberOfPliesHasError = true;
        this.toast.error(this.$t("editComponent.numberOfPliesError") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.numberOfPliesHasError;
    },
    // In imperial the thickness/diameter/wastage fields are shown in inches; the value is always stored in cm.
    toDisplayValue(cmValue: any, decimals: number): any {
      if (cmValue === null || cmValue === undefined || cmValue === "") {
        return cmValue;
      }
      const num = Number(cmValue);
      if (Number.isNaN(num)) {
        return cmValue;
      }
      return this.seamLengthUnit == 1 ? Number((num / 2.54).toFixed(decimals)) : num;
    },
    toCmValue(displayValue: any, decimals: number): any {
      if (displayValue === null || displayValue === undefined || displayValue === "") {
        return null;
      }
      const num = Number(displayValue);
      if (Number.isNaN(num)) {
        return displayValue;
      }
      return this.seamLengthUnit == 1 ? Number((num * 2.54).toFixed(decimals)) : num;
    },
    // Needle distance is stored in the Bight unit (mm metric / inch imperial); show it in the box unit
    // (CM / inch), so metric divides by 10 while imperial (already inches, like the Bight field) is unchanged.
    toNeedleDistanceDisplay(internalValue: any): any {
      if (internalValue === null || internalValue === undefined || internalValue === "") {
        return internalValue;
      }
      const num = Number(internalValue);
      if (Number.isNaN(num)) {
        return internalValue;
      }
      return this.seamLengthUnit == 0 ? Number((num / 10).toFixed(2)) : num;
    },
    // Material thickness: required under V4; greater than 0 and up to 999.99999 (up to 5 dp).
    validateMaterialThickness(): boolean {
      this.materialThicknessHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.materialThickness;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      const num = Number(raw);
      const decimalPlaces = String(raw).includes(".") ? String(raw).split(".")[1].length : 0;
      if (isBlank || Number.isNaN(num) || num <= 0 || num > 999.99999 || decimalPlaces > 5) {
        this.materialThicknessHasError = true;
        this.toast.error(
          this.$t("editComponent.materialThicknessError", { max: this.toDisplayValue(999.99999, 5) }) as string,
          {
            toastClassName: "custom-error-toast",
            timeout: 5000
          }
        );
      }
      return this.materialThicknessHasError;
    },
    // Button thickness: required (> 0) only for a Button Sew (BS) operation; otherwise 0 or blank is allowed.
    validateButtonThickness(): boolean {
      this.buttonThicknessHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.buttonThickness;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      const num = Number(raw);
      const decimalPlaces = String(raw).includes(".") ? String(raw).split(".")[1].length : 0;
      if (this.operationInputData.operationType === "BS") {
        if (isBlank || Number.isNaN(num) || num <= 0 || num > 999.99999 || decimalPlaces > 5) {
          this.buttonThicknessHasError = true;
          this.toast.error(
            this.$t("editComponent.buttonThicknessRequiredError", { max: this.toDisplayValue(999.99999, 5) }) as string,
            {
              toastClassName: "custom-error-toast",
              timeout: 5000
            }
          );
        }
      } else if (!isBlank && (Number.isNaN(num) || num < 0 || num > 999.99999 || decimalPlaces > 5)) {
        this.buttonThicknessHasError = true;
        this.toast.error(
          this.$t("editComponent.buttonThicknessError", { max: this.toDisplayValue(999.99999, 5) }) as string,
          {
            toastClassName: "custom-error-toast",
            timeout: 5000
          }
        );
      }
      return this.buttonThicknessHasError;
    },
    // Thread diameter: required under V4; greater than 0 and up to 999.99999 (up to 5 dp).
    validateThreadDiameter(): boolean {
      this.threadDiameterHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.threadDiameter;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      const num = Number(raw);
      const decimalPlaces = String(raw).includes(".") ? String(raw).split(".")[1].length : 0;
      if (isBlank || Number.isNaN(num) || num <= 0 || num > 999.99999 || decimalPlaces > 5) {
        this.threadDiameterHasError = true;
        this.toast.error(
          this.$t("editComponent.threadDiameterError", { max: this.toDisplayValue(999.99999, 5) }) as string,
          {
            toastClassName: "custom-error-toast",
            timeout: 5000
          }
        );
      }
      return this.threadDiameterHasError;
    },
    // Wastage per seam: optional; 0 to 99999.99 (up to 2 dp) when entered.
    validateWastagePerSeam(): boolean {
      this.wastagePerSeamHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const raw = this.operationInputData.wastagePerSeam;
      const isBlank = raw === null || raw === undefined || (raw as unknown as string) === "";
      if (isBlank) {
        return false;
      }
      const num = Number(raw);
      const decimalPlaces = String(raw).includes(".") ? String(raw).split(".")[1].length : 0;
      if (Number.isNaN(num) || num < 0 || num > 99999.99 || decimalPlaces > 2) {
        this.wastagePerSeamHasError = true;
        this.toast.error(
          this.$t("editComponent.invalidWastagePerSeam", { max: this.toDisplayValue(99999.99, 2) }) as string,
          {
            toastClassName: "custom-error-toast",
            timeout: 5000
          }
        );
      }
      return this.wastagePerSeamHasError;
    },
    // Operation type: required under V4.
    validateOperationType(): boolean {
      this.operationTypeHasError = false;
      if (!this.isV4CalculationEngine) {
        return false;
      }
      const value = this.operationInputData.operationType;
      if (value === null || value === undefined || String(value).trim() === "") {
        this.operationTypeHasError = true;
        this.toast.error(this.$t("editComponent.operationTypeError") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.operationTypeHasError;
    },
    // Stitch type: always required. The dropdown's change handler sets this flag too, but it never runs
    // when the user leaves the dropdown untouched, so re-check the value here before saving.
    validateStitchType(): boolean {
      const value = this.operationInputData.stitchTypeCode;
      this.stitchHasError = value === null || value === undefined || String(value).trim() === "";
      if (this.stitchHasError) {
        this.toast.error(this.$t("editComponent.pleaseSelectStitchType") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.stitchHasError;
    },
    async getStitchTypeData(): Promise<void> {
      await this.stitchTypeApi
        .apiGetStitchTypesOrderByMostFrequentlyUsedGet(Number(sessionStorage.customSettingId))
        .then(async res => {
          let stitchType: any = [];
          for (let product of res.data) {
            stitchType.push(product.code + "-" + product.name);
          }
          this.stitchTypeData.push(stitchType);
          this.defaultStitchData.push(res.data);
        });
    },
    async getRecentlyUsedStitchData(
      styleId: number,
      stitchCode: string,
      seamLengthUnit: number,
      ticketTex: string
    ): Promise<void> {
      this.removingNonRequiredField();
      await this.styleOperationApi
        .apiGetRecentlyUsedStyleOperationStitchDataGet(styleId, stitchCode, seamLengthUnit, ticketTex)
        .then(async res => {
          let status: string = res.statusText;
          if (status === "OK") {
            this.operationInputData.seamLength = res.data.seamLength;
            this.operationInputData.quantity = res.data.quantity;
            this.operationInputData.bight = res.data.bight;
            this.operationInputData.rate = res.data.rate;
            this.operationInputData.machines = res.data.machines;
            this.operationInputData.seamThikness = res.data.seamThikness;
            this.operationInputData.styleOperations = res.data.styleOperations;
            if (this.isV4CalculationEngine) {
              // Prefill the GSD V4 seam-detail fields from the last saved operation for this stitch code.
              this.operationInputData.numberOfPlies = res.data.numberOfPlies ?? 1;
              this.operationInputData.materialThickness = res.data.materialThickness ?? null;
              this.operationInputData.buttonThickness = res.data.buttonThickness ?? null;
              this.operationInputData.threadDiameter = res.data.threadDiameter ?? null;
              this.operationInputData.wastagePerSeam = res.data.wastagePerSeam ?? 0;
              this.operationInputData.operationType =
                normalizeOperationType(res.data.operationType) ?? OperationType.Sew;
              // Changing the stitch type behaves like an add: needle distance is derived from the formula
              // (bight / (needleCount - 1)), so leave it null and let needleDistanceDisplay compute it live.
              this.operationInputData.needleDistance = null;
            }
            this.getBrandNameById();
            await this.getNeedles(stitchCode);
            const recentRows: StyleOperationNBLC[] = this.operationInputData.styleOperations ?? [];
            const isExpanded = this.operationInputData.isMultiComponentThread;
            const isSavedPerPart = recentRows.some((so: any) => so.componentNo != null);
            if (!isExpanded || !isSavedPerPart || recentRows.length < this.needlesList.length) {
              const rows = this.needlesList.map((needleName: any) => {
                const matches = recentRows.filter((so: any) => so.needleName === needleName);
                const op = matches.find((so: any) => so.componentNo == null || so.componentNo === 1) ?? matches[0];
                if (op) {
                  return { ...op, componentNo: null };
                } else {
                  return {
                    needleName,
                    brandId: null,
                    ticketTex: null,
                    shade: null,
                    packageSize: null
                  } as StyleOperationNBLC;
                }
              });
              // an expanded operation gets each head type's selection on all of its parts
              this.setRows(isExpanded ? this.copyToParts(rows) : rows);
            }
          } else {
            this.setDefaultData(stitchCode);
            this.operationInputData.styleOperations = null;
            this.brandName = {};
            if (this.isV4CalculationEngine) {
              // No prior operation for this stitch code — prefill V4 seam-detail fields from the
              // stitch type master (AppStitchTypes); fall back to defaults when the master has no value.
              const masterStitchType = this.defaultStitchData?.[0]?.find((item: any) => item.code == stitchCode);
              this.operationInputData.numberOfPlies = masterStitchType?.numberOfPlies ?? 1;
              this.operationInputData.materialThickness = masterStitchType?.materialThickness ?? null;
              this.operationInputData.buttonThickness = masterStitchType?.buttonThickness ?? null;
              this.operationInputData.threadDiameter = masterStitchType?.threadDiameter ?? null;
              this.operationInputData.wastagePerSeam = masterStitchType?.wastagePerSeam ?? 0;
              this.operationInputData.operationType =
                normalizeOperationType(masterStitchType?.operationType) ?? OperationType.Sew;
              // Changing the stitch type behaves like an add: derive needle distance from the formula.
              this.operationInputData.needleDistance = null;
            }
          }
        });
    },
    async getStitchCode(stitchType: string): Promise<boolean> {
      if (stitchType == "" || stitchType == undefined || stitchType == null) {
        this.showHeader = false;
        this.stitchHasError = true;
        this.showBight = true;
        this.showSeamLength = true;
        this.showSeamThickness = true;
        this.showRate = true;
        this.showQuantity = true;
        this.imageUrl = "/StitchTypeImages/EmptyImage.jpg";
        this.toast.error(this.$t("editComponent.pleaseSelectStitchType") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.stitchHasError = false;
        this.showHeader = true;
        this.operationInputData.stitchTypeCode = stitchType?.split("-")[0] as string;
        this.selectedImageUrl();
        this.loadNeedleCount(this.operationInputData.stitchTypeCode);
        this.setConsumptionData(this.operationInputData.stitchTypeCode);
        await this.getRecentlyUsedStitchData(
          this.styleId as unknown as number,
          stitchType?.split("-")[0] as string,
          this.seamLengthUnit,
          this.ticketTex as string
        );
        if (this.operationInputData.styleOperations == null || this.operationInputData.styleOperations?.length == 0) {
          let styleOperationNblc: Array<StyleOperationNBLC> = [];
          await this.stitchNBLCTypesApi
            .apiGetStitchNeedlesByStitchTypeCodeGet(stitchType?.split("-")[0] as string)
            .then(async res => {
              for (let val of res.data) {
                let styleOprNblc: StyleOperationNBLC = {
                  needleName: val,
                  brandId: null,
                  ticketTex: null,
                  shade: null,
                  packageSize: null
                };
                styleOperationNblc.push(styleOprNblc);
              }
            });
          this.operationInputData.styleOperations = styleOperationNblc;
          this.getBrandData();
          this.getShadeData();
          this.removingNonRequiredField();
        }
        if (this.operationInputData.isMultiComponentThread) {
          this.rowsBeforeExpand = null;
          this.expandRows(this.operationInputData.styleOperations ?? []);
        }
        this.validateOperationStitchType();
      }
      return this.stitchHasError;
    },
    // Keep the operation type / stitch type pair checked as soon as either one is picked, so the
    // warning appears on selection; ValidateRequiredFields still re-checks it at save time.
    handleOperationTypeChange(operationType: OperationType): void {
      this.operationInputData.operationType = operationType;
      this.validateOperationStitchType();
    },
    async getNeedles(stitchCode: string) {
      this.needlesList = [];
      await this.stitchNBLCTypesApi.apiGetStitchNeedlesByStitchTypeCodeGet(stitchCode).then(async res => {
        for (let value of res.data) {
          this.needlesList.push(value);
        }
      });
    },
    // StitchType.Needles from the already-loaded stitch list; local fallback for the needle count.
    localStitchNeedleCount(stitchTypeCode?: string | null): number {
      const stitchList = this.defaultStitchData?.[0];
      const code = stitchTypeCode?.split("-")[0]?.trim();
      if (!Array.isArray(stitchList) || !code) return 0;
      const stitch = stitchList.find((item: any) => String(item.code) === String(code));
      return Number(stitch?.needles ?? 0);
    },
    // Load the needle count for the stitch type from its NBLC rows (sum of Heads across needle rows).
    async loadNeedleCount(stitchTypeCode?: string | null): Promise<void> {
      const code = stitchTypeCode?.split("-")[0]?.trim();
      if (!code) {
        this.needleCount = 0;
        return;
      }
      // Seed from local stitch metadata so non-listed stitch types keep their derived distance during
      // load and if the NBLC endpoint is unavailable (AC5); then refine with the authoritative NBLC count.
      this.needleCount = this.localStitchNeedleCount(code);
      try {
        const res = await this.stitchNBLCTypesApi.apiGetNeedleCountByStitchTypeCodeGet(code);
        // Guard against a stale response: if the user switched stitch type while this request was in
        // flight, the current stitch no longer matches and its needle count must not be overwritten.
        if (code !== this.operationInputData.stitchTypeCode?.split("-")[0]?.trim()) return;
        this.needleCount = Number(res.data ?? 0);
      } catch {
        // Keep the local fallback already set above.
      }
    },
    async getComponentData(stitchCode: string): Promise<void> {
      this.showHeader = true;
      // kept for an operation saved expanded to components: its part rows are rebuilt from these below
      const savedRows: StyleOperationNBLC[] = [...(this.operationInputData.styleOperations ?? [])];
      await this.stitchNBLCTypesApi.apiGetStitchNeedlesByStitchTypeCodeGet(stitchCode).then(async res => {
        const orderedOperations: StyleOperationNBLC[] = res.data.map((needleName: string) => {
          const op = this.operationInputData.styleOperations.find((so: any) => so.needleName === needleName);
          if (op) {
            return op;
          } else {
            return {
              needleName,
              brandId: null,
              ticketTex: null,
              shade: null,
              packageSize: null
            } as StyleOperationNBLC;
          }
        });
        this.operationInputData.styleOperations = orderedOperations;
        this.brandName = this.operationInputData.styleOperations.map((op: any) => {
          return this.brandData.find((a: { value: string }) => String(a.value) === String(op.brandId))?.value || null;
        });
        for (let [index, op] of this.operationInputData.styleOperations.entries()) {
          this.initialPackageSizeData[index] = op.packageSize == null ? null : op.packageSize;
        }
      });
      if (this.operationInputData.isMultiComponentThread) {
        this.expandRows(savedRows);
      }
      this.getBrandData();
      this.getShadeData();
    },
    // split the rows into one row per part (needle 1, needle 2, ...), keeping the given
    // selections. The parts and their consumption come from the consumption data the operation list loaded.
    expandRows(savedRows: StyleOperationNBLC[]): void {
      const code = this.operationInputData.stitchTypeCode?.split("-")[0]?.trim() ?? "";
      this.headTypes = toHeadTypes(this.consumptionData?.[code]?.components ?? []);
      this.setRows(buildLeafRows(this.headTypes, savedRows, true));
    },
    // Show the given rows and refresh the brand / package size state of each row.
    setRows(rows: StyleOperationNBLC[]): void {
      this.operationInputData.styleOperations = rows;
      this.brandName = this.operationInputData.styleOperations.map((op: any) => {
        return this.brandData.find((a: { value: string }) => String(a.value) === String(op.brandId))?.value || null;
      });
      this.initialPackageSizeData = {};
      for (let [index, op] of this.operationInputData.styleOperations.entries()) {
        this.initialPackageSizeData[index] = op.packageSize == null ? null : op.packageSize;
      }
    },
    // Ticking splits the rows into part rows that start with their head type's selection;
    // unticking before save brings back the rows as they were.
    onExpandToComponentsChange(): void {
      if (this.operationInputData.isMultiComponentThread) {
        this.rowsBeforeExpand = (this.operationInputData.styleOperations ?? []).map((row: any) => ({ ...row }));
        this.expandRows(this.copyToParts(this.rowsBeforeExpand));
      } else {
        this.setRows(buildLeafRows(this.headTypes, [], false));
        this.rowsBeforeExpand = null;
      }
    },
    // Copies each head type's selection to all of its parts; the user then changes the ones that differ.
    copyToParts(headRows: StyleOperationNBLC[]): StyleOperationNBLC[] {
      const code = this.operationInputData.stitchTypeCode?.split("-")[0]?.trim() ?? "";
      const parts = this.consumptionData?.[code]?.components ?? [];
      const copies: StyleOperationNBLC[] = [];
      for (const row of headRows) {
        const count = parts.filter((part: any) => part.headName === (row.needleName ?? "").trim()).length;
        for (let i = 0; i < Math.max(count, 1); i++) copies.push({ ...row });
      }
      return copies;
    },
    async getShadeData(): Promise<void> {
      this.shadeData = [];
      await this.shadeApi.apiShadeGetShadesOrderByMostFrequentlyUsedGet().then(async res => {
        for (let shade of res.data) {
          let data = {
            text: shade.name,
            value: shade.name
          };
          this.shadeData.push(data);
        }
      });
    },
    async getBrandData(): Promise<void> {
      this.brandData = [];
      await this.brandApi.apiGeBrandsOrderByMostFrequentlyUsedGet().then(async (res: { data: any[] }) => {
        for (let brand of res.data) {
          let data = {
            text: brand.name,
            value: brand.id
          };
          this.brandData.push(data);
        }
      });
    },
    async getBrandNameById(): Promise<void> {
      this.brandName = {};
      let i = 0;
      for (let res of this.operationInputData.styleOperations) {
        this.brandName[i] =
          this.brandData.find((a: { value: string }) => (a.value as string) == res.brandId)?.text || null;
        i++;
      }
    },
    async getTktTexData(brandId: number, id: number): Promise<void> {
      this.tktTexData = [];
      this.operationInputData.styleOperations[id].brandId = brandId;
      this.brandName[id] = this.brandData.find((a: { value: string }) => +a.value == brandId)?.text;
      if (brandId != null && brandId > 0) {
        await this.ticketTexApi.apiGetTickeTexsByBrandIdGet(brandId).then(async res => {
          for (let value of res.data) {
            let ticketOrTex = this.ticketTex == "Tkt" ? value.ticket : value.tex;
            let data = {
              text: ticketOrTex,
              value: ticketOrTex
            };
            this.tktTexData.push(data);
          }
        });
      } else {
        this.operationInputData.styleOperations[id].ticketTex = null;
        this.operationInputData.styleOperations[id].packageSize = null;
      }
    },
    async getTktTexIdByValue(brandId: number, ticketTex: string, tktTex: string): Promise<number> {
      let tktTexId = 0;
      await this.ticketTexApi.apiGetTickeTexsByBrandIdGet(brandId).then(async res => {
        tktTexId =
          ticketTex == "Tkt"
            ? (res.data.find(a => a.ticket == tktTex)?.id as number)
            : (res.data.find(a => a.tex == tktTex)?.id as number);
      });
      return tktTexId;
    },
    async getPackageSizeData(tktTex: string, id: number): Promise<void> {
      this.operationInputData.styleOperations[id].ticketTex = tktTex;
      this.packageSizeData = [];
      this.tktTexData = [];
      this.operationInputData.styleOperations[id].packageSize = null;
      if (this.operationInputData.styleOperations[id].brandId != null) {
        this.getTktTexData(this.operationInputData.styleOperations[id].brandId, id);
      }
      if (tktTex != null) {
        let tktTexId = await this.getTktTexIdByValue(
          this.operationInputData.styleOperations[id].brandId as number,
          this.ticketTex as string,
          tktTex
        );
        await this.packageSizeApi.apiGetPacakageSizesByTicketTexIDGet(tktTexId).then(async res => {
          for (let value of res.data) {
            let data = {
              value: value.size,
              text: value.size
            };
            this.packageSizeData.push(data);
          }
        });
      }
    },
    validationForSeamLength(): boolean {
      // BH/BT/BS/AC hold a stitch count in this box, whose agreed data entry range is 0 to 9999999.99.
      const isStitchCount =
        this.isV4CalculationEngine && ["BH", "BT", "BS", "AC"].includes(String(this.operationInputData.operationType));
      if (
        (this.operationInputData.seamLength ? this.operationInputData.seamLength : 0) < 0 ||
        this.operationInputData.seamLength == undefined ||
        (isStitchCount && String(this.operationInputData.seamLength) === "")
      ) {
        this.seamLengthHasError = true;
        if (!isStitchCount)
          this.toast.error(this.$t("editComponent.pleaseEnterSeamLength") as string, {
            toastClassName: "custom-error-toast",
            timeout: 5000
          });
      } else {
        // Over the agreed range: highlight the box in red only, no message.
        this.seamLengthHasError = isStitchCount && Number(this.operationInputData.seamLength) > 9999999.99;
      }
      return this.seamLengthHasError;
    },
    getMachine(): boolean {
      if (
        (this.operationInputData.machines ? this.operationInputData.machines : 0) <= 0 ||
        this.operationInputData.machines == undefined
      ) {
        this.machineHasError = true;
        this.toast.error(this.$t("editComponent.pleaseEnterMachine") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.machineHasError = false;
      }
      return this.machineHasError;
    },
    // Distance between needle: editable for the listed GSD V4 stitch types; must be from 0.01 cm up to the Bight.
    validateNeedleDistance(): boolean {
      this.needleDistanceHasError = false;
      // A needle distance can never fit inside a wrong Bight, so only the Bight message is shown until it is corrected.
      if (!this.isNeedleDistanceEditable || this.bightHasError) {
        return false;
      }
      const raw = this.operationInputData.needleDistance;
      const isBlank = raw === null || raw === undefined || String(raw).trim() === "";
      const value = isBlank ? this.needleDistance : Number(raw);
      const bight = Number(this.operationInputData.bight ?? 0);
      // The smallest needle distance allowed is 0.01 cm (0.1 mm), converted into the unit the value is held in.
      const minNeedleDistance = 0.1 / this.bightConversionFactor;
      if (Number.isNaN(value) || value < minNeedleDistance || value > bight) {
        this.needleDistanceHasError = true;
        // A needle distance bigger than the Bight has its own message; every other wrong value gets the minimum message.
        const messageKey =
          value > bight ? "editComponent.needleDistanceGreaterThanBightError" : "editComponent.needleDistanceError";
        // The minimum is shown in the unit of the box at the same 5-decimal precision as the other seam-detail fields.
        const min = Number(this.toNeedleDistanceDisplay(minNeedleDistance).toFixed(5));
        this.toast.error(this.$t(messageKey, { min, unit: this.unitLabel }) as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.needleDistanceHasError;
    },
    // Bight: required for the listed GSD V4 stitch types, so it must be greater than 0.
    validateBight(): boolean {
      // An empty box gives 0, so this one check covers both an empty box and a wrong value.
      const bight = Number(this.operationInputData.bight);
      // Convert the limit into the unit the box is showing. Any Bight greater than 0 is allowed.
      const maxBight = V4_MAX_BIGHT_IN_MM / this.bightConversionFactor;
      if (this.applyV4BightRule && (bight <= 0 || bight > maxBight)) {
        // The flag highlights the Bight box in red until the value is corrected.
        this.bightHasError = true;
        // A Bight above the maximum has its own message; 0 or less gets the "greater than 0" message.
        const messageKey = bight > maxBight ? "editComponent.bightGreaterThanMaxError" : "editComponent.bightError";
        // The maximum is shown in the unit of the Bight box (mm or inch) at the 2-decimal precision of the box.
        const max = Number(maxBight.toFixed(2));
        const unit = this.bightConversionFactor == 1 ? "mm" : "inch";
        this.toast.error(this.$t(messageKey, { max, unit }) as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.bightHasError = false;
      }
      return this.bightHasError;
    },
    // Stitch type: only 101, 104, 107, 304 and 404 may be used with a Button Hole, Bartack or
    // Button Sew operation under V4. Other operation types are unaffected.
    validateOperationStitchType(): boolean {
      const { operationType, stitchTypeCode } = this.operationInputData;
      this.operationStitchTypeHasError =
        this.isV4CalculationEngine && isInvalidOperationStitchType(operationType, stitchTypeCode);
      if (this.operationStitchTypeHasError) {
        this.toast.error(this.$t("editComponent.buttonOperationStitchTypeError") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return this.operationStitchTypeHasError;
    },
    ValidateRequiredFields(): boolean {
      this.validateDescription();
      this.validationForSeamLength();
      this.getMachine();
      this.validateSeamThickness();
      this.validateNumberOfPlies();
      this.validateMaterialThickness();
      this.validateButtonThickness();
      this.validateThreadDiameter();
      this.validateWastagePerSeam();
      this.validateBight();
      this.validateNeedleDistance();
      this.validateOperationType();
      this.validateStitchType();
      this.validateOperationStitchType();

      const hasBasicRequiredError =
        this.descHasError || this.stitchHasError || this.seamLengthHasError || this.machineHasError;
      if (hasBasicRequiredError) {
        this.toast.error(this.$t("editComponent.pleaseFillRequiredData") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      return (
        hasBasicRequiredError ||
        this.seamThicknessHasError ||
        this.numberOfPliesHasError ||
        this.materialThicknessHasError ||
        this.buttonThicknessHasError ||
        this.threadDiameterHasError ||
        this.wastagePerSeamHasError ||
        this.needleDistanceHasError ||
        this.bightHasError ||
        this.operationTypeHasError ||
        this.operationStitchTypeHasError
      );
    },
    containsOnlyNumbers(str: string): boolean {
      return /^\d+$/.test(str);
    },
    async onSaveOperationData(): Promise<void> {
      let isError: boolean = this.ValidateRequiredFields();
      if (!this.isStitchTypeValidation.every(Boolean)) {
        this.toast.error(this.$t("editComponent.errorInSavingOperationWithSameGroup") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
        return;
      }

      if (isError) {
        return;
      }

      this.operationInputData.description = this.operationInputData.description?.trim();
      if (this.isV4CalculationEngine) {
        this.operationInputData.seamThikness = 0;
        // Persist the shown needle distance for every stitch type: the entered/loaded value, or the
        // calculated default (bight / (needles - 1)); null only when there is genuinely none. Guard on
        // showNeedleDistance rather than the value so a legitimate 0 (e.g. bight 0) is preserved.
        this.operationInputData.needleDistance =
          this.operationInputData.needleDistance ?? (this.showNeedleDistance ? this.needleDistance : null);
      } else {
        // Seamworks: the per-operation V4 fields don't apply — store null.
        this.operationInputData.numberOfPlies = null;
        this.operationInputData.materialThickness = null;
        this.operationInputData.buttonThickness = null;
        this.operationInputData.threadDiameter = null;
        this.operationInputData.wastagePerSeam = null;
        this.operationInputData.needleDistance = null;
        this.operationInputData.operationType = null;
      }
      for (let operation of this.operationInputData.styleOperations) {
        if (operation.shade != null) operation.shade = operation.shade.trim();
      }
      const result = await this.styleOperationApi.apiValidateAlreadyExistingOperationWithSameGroupPost(
        this.operationIdLocal,
        this.ticketTex as string,
        this.operationInputData
      );
      if (result.data) {
        await this.styleOperationApi
          .apiEditOperationPost(this.ticketTex as string, this.operationInputData)
          .then(res => {
            if (res.data === -1) {
              this.toast.error(this.$t("editComponent.errorInSavingOperation") as string, {
                toastClassName: "custom-error-toast",
                timeout: 5000
              });
            } else {
              this.operationIdLocal = res.data;
              this.$emit("operationId", this.operationIdLocal);
              this.$emit("getOperationData");
              this.operationInputData.id = this.operationIdLocal;
              this.isMultiComponentThreadSaved = this.operationInputData.isMultiComponentThread ?? false;
              this.toast.success(this.$t("editComponent.operationSavedSuccessfully") as string, {
                toastClassName: "custom-success-toast",
                timeout: 5000
              });
            }
          })
          .catch((error: any) => {
            // Show the backend's localized UserFriendlyException message (set by the response interceptor).
            this.toast.error(error.errorMsg ?? (this.$t("editComponent.errorInSavingOperation") as string), {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          });
      } else {
        this.toast.error(this.$t("editComponent.errorInSavingOperationWithSameGroup") as string, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    onBightChange(): void {
      // For the listed (editable) stitch types the needle distance is entered by the user, so a bight change
      // must not overwrite it. For other stitch types it's the even-spacing default (bight / (needles - 1)),
      // so keep it in sync with the bight.
      if (!this.isV4CalculationEngine || this.isNeedleDistanceEditable) {
        return;
      }
      this.$nextTick(() => {
        this.operationInputData.needleDistance = this.needleDistance || null;
      });
    },
    setConversionFactor(unit: number): void {
      if (unit == 1) {
        this.bightConversionFactor = 25.4;
        this.seamlengthConversionFector = 2.54;
        this.rateConversionFactor = 1.181103;
      }
    },
    async setDefaultData(stitchCode: string): Promise<void> {
      const stitchTypeFound = this.defaultStitchData[0].find(
        (item: any) => item.code == this.operationInputData.stitchTypeCode
      );
      this.showQuantity = true;
      this.showBight = true;
      this.showRate = true;
      this.showSeamThickness = true;
      this.showSeamLength = true;
      switch (stitchCode) {
        case "101":
        case "102":
        case "1014":
        case "103":
        case "104":
        case "105":
        case "107":
        case "108":
        case "201":
        case "204":
        case "205":
        case "206":
        case "209":
        case "211":
        case "213":
        case "214":
        case "215":
        case "217":
        case "219":
        case "220":
        case "317":
        case "318":
        case "404":
        case "405":
        case "411":
        case "412":
        case "413":
        case "414":
        case "415":
        case "416":
        case "417": {
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "301":
        case "319":
        case "401":
        case "401A": {
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.operationInputData.seamThikness = stitchTypeFound.seamThikness;
          this.showBight = false;
          break;
        }
        case "109":
        case "4041": {
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showSeamThickness = false;
          break;
        }
        case "327": {
          this.operationInputData.bight = (2 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "503": {
          this.operationInputData.bight = (2.5 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "302":
        case "303":
        case "304":
        case "305":
        case "306":
        case "307":
        case "308":
        case "309":
        case "310":
        case "311":
        case "312":
        case "314":
        case "322":
        case "324":
        case "326":
        case "402":
        case "403":
        case "410":
        case "501":
        case "502":
        case "505":
        case "506":
        case "507":
        case "508":
        case "509":
        case "512": {
          this.operationInputData.bight = (4 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "504":
        case "514": {
          this.operationInputData.bight = (4 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.seamThikness = stitchTypeFound.seamThikness;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          break;
        }
        case "409": {
          this.operationInputData.bight = (4 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.operationInputData.seamThikness = stitchTypeFound.seamThikness;
          break;
        }
        case "313":
        case "320":
        case "321":
        case "323":
        case "325":
        case "408":
        case "601":
        case "604":
        case "606":
        case "609":
        case "515": {
          this.operationInputData.bight = (6 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "406":
        case "407":
        case "602":
        case "605":
        case "607":
        case "607K": {
          this.operationInputData.bight = (6 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.seamThikness = stitchTypeFound.seamThikness;
          this.operationInputData.quantity = 1;
          this.showSeamThickness = true;
          this.showQuantity = false;
          break;
        }
        case "516": {
          this.operationInputData.bight = (6 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.seamThikness = stitchTypeFound.seamThikness;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          break;
        }
        case "328": {
          this.operationInputData.bight = (8 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "4083": {
          this.operationInputData.bight = (10 / this.bightConversionFactor).toFixed(2) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "1013":
        case "3013":
        case "3043":
        case "4012":
        case "4013":
        case "4013G":
        case "4043": {
          this.operationInputData.seamLength = (2 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showRate = false;
          this.showSeamThickness = false;
          break;
        }
        case "4012G": {
          this.operationInputData.seamLength = (2 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.operationInputData.seamThikness = stitchTypeFound.seamThikness;
          this.showBight = false;
          this.showRate = false;
          break;
        }
        case "1015":
        case "3045":
        case "4045":
        case "3015": {
          this.operationInputData.seamLength = (1 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showSeamThickness = false;
          break;
        }
        case "1012":
        case "1016":
        case "3012":
        case "3042":
        case "4042": {
          this.operationInputData.quantity = 1;
          this.operationInputData.machines = 1;
          this.operationInputData.seamLength = (1 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.showBight = false;
          this.showSeamLength = false;
          this.showRate = false;
          this.showSeamThickness = false;
          break;
        }
        //non ISO stitch types, sewn along a seam, so no seam thickness. Quantity and machines default to 1.
        case "315":
        case "316":
        case "329":
        case "351":
        case "510":
        case "511":
        case "513":
        case "521":
        case "522":
        case "603":
        case "608": {
          this.operationInputData.bight = ((stitchTypeFound.defaultBight * 10) / this.bightConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = true;
          this.showSeamLength = true;
          this.showRate = true;
          this.showQuantity = true;
          this.showSeamThickness = false;
          break;
        }
        case "202": {
          this.operationInputData.seamLength = (10 / this.seamlengthConversionFector).toFixed(2) as unknown as number;
          this.operationInputData.rate = (stitchTypeFound.stdStitchRate / this.rateConversionFactor).toFixed(
            2
          ) as unknown as number;
          this.operationInputData.machines = 1;
          this.operationInputData.quantity = 1;
          this.showBight = false;
          this.showSeamLength = true;
          this.showRate = true;
          this.showQuantity = true;
          this.showSeamThickness = false;
          break;
        }
        default: {
          break;
        }
      }
      // GSD V4: the listed stitch types always take a Bight, whatever the switch above decided.
      if (this.applyV4BightRule) {
        this.showBight = true;
        // The stitch type stores its default in cm, so multiply by 10 to get mm.
        let bightInMm = Number(stitchTypeFound.defaultBight) * 10;
        if (bightInMm <= 0) {
          // This stitch type has no default of its own, so use the standard 3 mm.
          bightInMm = V4_DEFAULT_BIGHT_IN_MM;
        }
        this.operationInputData.bight = (bightInMm / this.bightConversionFactor).toFixed(2) as unknown as number;
      }
    },
    async removingNonRequiredField(): Promise<void> {
      this.showQuantity = true;
      this.showBight = true;
      this.showRate = true;
      this.showSeamThickness = true;
      this.showSeamLength = true;
      switch (this.operationInputData.stitchTypeCode) {
        case "1012":
        case "1016":
        case "3012":
        case "3042":
        case "4042": {
          this.showBight = false;
          this.showSeamLength = false;
          this.showSeamThickness = false;
          this.showRate = false;
          break;
        }
        case "101":
        case "102":
        case "1014":
        case "103":
        case "104":
        case "105":
        case "107":
        case "108":
        case "201":
        case "204":
        case "205":
        case "206":
        case "209":
        case "211":
        case "213":
        case "214":
        case "215":
        case "217":
        case "219":
        case "220":
        case "317":
        case "318":
        case "404":
        case "405":
        case "411":
        case "412":
        case "413":
        case "414":
        case "415":
        case "416":
        case "417": {
          this.showBight = false;
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "1013":
        case "3013":
        case "3043":
        case "4012":
        case "4013":
        case "4013G":
        case "4043": {
          this.showBight = false;
          this.showRate = false;
          this.showSeamThickness = false;
          break;
        }
        case "1015":
        case "109":
        case "3015":
        case "3045":
        case "4041":
        case "4045": {
          this.showBight = false;
          this.showSeamThickness = false;
          break;
        }
        case "302":
        case "303":
        case "304":
        case "305":
        case "306":
        case "307":
        case "308":
        case "309":
        case "310":
        case "311":
        case "312":
        case "313":
        case "314":
        case "320":
        case "321":
        case "322":
        case "323":
        case "324":
        case "325":
        case "326":
        case "327":
        case "328":
        case "402":
        case "403":
        case "408":
        case "4083":
        case "410":
        case "501":
        case "502":
        case "503":
        case "505":
        case "506":
        case "507":
        case "508":
        case "509":
        case "512":
        case "515":
        case "601":
        case "604":
        case "606":
        case "609": {
          this.showQuantity = false;
          this.showSeamThickness = false;
          break;
        }
        case "4012G": {
          this.showRate = false;
          this.showBight = false;
          break;
        }
        case "301":
        case "319":
        case "401":
        case "401A": {
          this.showBight = false;
          break;
        }
        case "406":
        case "407":
        case "504":
        case "514":
        case "602":
        case "605":
        case "607K":
        case "516":
        case "607": {
          this.showQuantity = false;
          break;
        }
        //non ISO stitch types always show quantity and machines, so set every flag explicitly.
        case "315":
        case "316":
        case "329":
        case "351":
        case "510":
        case "511":
        case "513":
        case "521":
        case "522":
        case "603":
        case "608": {
          this.showBight = true;
          this.showSeamLength = true;
          this.showRate = true;
          this.showQuantity = true;
          this.showSeamThickness = false;
          break;
        }
        case "202": {
          this.showBight = false;
          this.showSeamLength = true;
          this.showRate = true;
          this.showQuantity = true;
          this.showSeamThickness = false;
          break;
        }
        default: {
          break;
        }
      }
      // GSD V4: the listed stitch types always take a Bight, whatever the switch above decided.
      if (this.applyV4BightRule) {
        this.showBight = true;
      }
    }
  },
  async created(): Promise<void> {
    this.loadData();
  }
});
</script>
<style scoped>
.input {
  width: 100%;
  height: 31px;
  border: 1px solid #d1d5db;
  color: #222;
  background: #fff;
  border-radius: 2px;
  text-align: right;
  padding: 4px 8px;
}

.label,
.label1 {
  font-size: 12px;
  color: #222;
  margin-bottom: 4px;
}

.entry {
  display: flex;
  gap: 14px;
  margin-top: 10px;
  width: 48%;
}

.inputGroup {
  width: 48%;
  display: grid;
}

.team {
  width: 80px;
  display: grid;
}

.body {
  width: 48%;
  display: inline-grid;
  margin-top: 12px;
  vertical-align: top;
  position: relative;
}

.textArea {
  width: 100%;
  height: 90px;
  border: 1px solid #d1d5db;
  color: #222;
  background: #fff;
  resize: both;
  padding: 6px;
}

.counter {
  position: absolute;
  bottom: 4px;
  right: 18px;
  color: #767474;
  font-size: 11px;
  background: #fff;
  padding: 0 2px;
  pointer-events: none;
}

.stitchType {
  display: grid;
  width: 48%;
  margin-top: 12px;

  vertical-align: top;
}

.operationType {
  display: grid;
  width: 48%;
  margin-top: 12px;
  vertical-align: top;
}

.formComponent {
  display: inline-grid;
  width: 23.5%;
  margin-top: 10px;
  margin-right: 1.3%;
}

.formComponent .input {
  width: 100% !important;
}

.child {
  width: 100%;
  margin-top: 10px;
  padding-left: 0;
  max-width: none;
}

.buttons {
  margin-top: 22px;
}

.wastageNote {
  margin: 12px 0 0;
  font-size: 12px;
  color: #6c757d;
}
/* the checkbox sits under the stitch image without pushing the floated Seam Details box down */
.operation {
  position: relative;
}
.expandToComponents {
  position: absolute;
  right: 0;
  top: 98px;
  font-size: 13px;
  font-weight: 600;
}
.expandToComponents label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.modal-header {
  background-color: #0054a6;
  color: white;
  padding: 0.75rem;
  height: auto;
  border-radius: 0 !important;
}

.modal.right .modal-dialog {
  position: fixed;
  margin: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 55vw;
  max-width: 100vw;
  font-family: Arial, Helvetica, sans-serif;
}

.modal.right .modal-content {
  height: 100%;
  overflow-y: auto;
  border-radius: 0 !important;
}

.modal-body {
  padding: 14px;
  color: #000;
}

.btn-primary {
  background-color: #0054a6;
  color: white;
}

.errorStyle {
  border-color: red !important;
}

.k-input {
  font-size: 12px !important;
  padding: 0 !important;
}

.needlesTable {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
}

.needlesTable th,
.needlesTable td {
  border: none;
  border-bottom: 1px solid #eee;
  padding: 7px 8px;
  text-align: center;
  vertical-align: middle;
}

.needlesTable th {
  background: #f1f2f4;
  color: #444;
  font-size: 13px;
  font-weight: 700;
}

.needlesTable td:first-child,
.needlesTable th:first-child {
  text-align: left;
}
/* expanded thread rows */
.needlesTable tr.headRow td {
  background: #f7f8fa;
  font-weight: 600;
}
.needlesTable tr.headRow .componentCount {
  font-weight: 400;
  color: #666;
}
.needlesTable tr.headRow .chosenPerComponent {
  text-align: left;
  color: #8a8f98;
  font-weight: 400;
}
.needlesTable tr.componentRow td:first-child {
  padding-left: 28px;
}

.seam-details-box {
  float: right;
  width: 48%;
  margin-top: 30px;
  margin-right: 0;
  margin-bottom: 10px;
  color: #000;
}

.seam-details-box fieldset {
  border: 1px solid #dcdcdc;
  padding: 10px 16px 10px;
  border-radius: 2px;
  background: #fff;
  margin: 0;
  min-inline-size: 0;
}

.seam-details-box legend {
  width: auto;
  max-width: 100%;
  display: table;
  float: none;
  padding: 0 8px;
  margin: 0 0 0 12px;
  font-size: 12px;
  font-weight: 400;
  border: none;
  line-height: 1;
  color: #222;
  font-family: inherit;
  white-space: normal;
  background: #fff;
}

.seam-row {
  display: grid;
  grid-template-columns: 1fr 155px;
  align-items: center;
  gap: 14px;
  margin-bottom: 8px;
}

.seam-row label {
  font-size: 12px;
  color: #222;
  font-weight: 400;
  font-family: inherit;
  margin-bottom: 0;
}

.seam-input {
  height: 29px;
  border: 1px solid #d1d5db;
  text-align: right;
  padding: 4px 8px;
  font-size: 12px;
  color: #222;
  background: #fff;
  border-radius: 2px;
}

.seam-value {
  height: 29px;
  border: 1px solid #d1d5db;
  border-radius: 2px;
  padding: 4px 8px;
  font-size: 12px;
  /* Read-only field: muted text + grey fill signal it isn't editable. */
  color: #9ca3af;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

img[alt="Selected Stitch"] {
  float: right !important;
  padding: 0 !important;
  height: 90px !important;
  width: 125px !important;
  object-fit: contain;
  margin-right: 0;
  border: 1px dashed #e2e2e2;
}

.vue-js-switch .v-switch-input {
  position: relative !important;
  opacity: 0 !important;
  width: 40px !important;
  height: 40px !important;
  top: 12px !important;
  left: 7px !important;
  z-index: 1000 !important;
}

.vue-js-switch .v-switch-core {
  display: block !important;
  position: relative !important;
  top: -19px !important;
  left: 0 !important;
}

.vue-js-switch .v-switch-label {
  position: absolute !important;
  top: 9.5px !important;
  left: 30px !important;
  font-weight: 600 !important;
}

.modal {
  pointer-events: none !important;
}

.modal-content {
  pointer-events: auto !important;
}

.modal-backdrop {
  z-index: 10500;
}

.modal-header i.fa-times {
  color: white !important;
}

.headerText {
  font-size: 16px;
}
</style>

<!-- Non-scoped: Kendo appends the ComboBox popup to <body>, so scoped styles can't reach it.
     Scoped by the popup id so ONLY the Operation Type list is affected. Neutralise the global
     blue "selected" highlight so the open list matches the Stitch Type dropdown. -->
<style>
#operationType_listbox .k-list-item.k-selected,
#operationType_listbox .k-item.k-state-selected,
#operationType_listbox .k-list-optionlabel.k-state-selected {
  color: #333333 !important;
  background-color: #ffffff !important;
}
#operationType_listbox .k-list-item.k-selected.k-hover,
#operationType_listbox .k-list-item.k-selected:hover,
#operationType_listbox .k-item.k-state-selected.k-state-hover,
#operationType_listbox .k-item.k-state-selected:hover {
  background-color: #ebebeb !important;
}
</style>
